/** Bounds source scanning and the bindings created before sandbox execution. */
export const MAX_FUNCTION_CODE_LENGTH = 1024 * 1024
export const MAX_FUNCTION_REFERENCES = 10_000
